import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type AutomationRulesUpsellSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function AutomationRulesUpsellSvg(
  props: AutomationRulesUpsellSvgProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('AutomationRulesUpsellSvg', className)}
      width="181"
      height="214"
      viewBox="0 0 181 214"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_18702_103296)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.5781 149.856C74.2541 149.338 72.5913 147.294 72.5698 144.915L72.5702 144.915C72.5441 142.069 72.5061 138.268 72.4684 135.559C72.4446 133.536 71.2264 131.715 69.3637 130.92C65.7831 129.37 62.3784 127.44 59.2058 125.164C57.5654 123.976 55.3723 123.865 53.6197 124.894C51.2805 126.268 48.0042 128.19 45.5438 129.625C43.4984 130.826 40.8921 130.459 39.262 128.737C36.394 125.665 33.8005 122.347 31.5002 118.831C30.2232 116.829 30.4958 114.203 32.1644 112.51C34.1574 110.477 36.816 107.765 38.7071 105.817C40.1249 104.371 40.5517 102.228 39.7952 100.35C38.3633 96.7188 37.3135 92.9504 36.6839 89.0991C36.3649 87.0955 34.892 85.4684 32.9286 84.9604C30.3007 84.2779 26.62 83.3215 23.8655 82.5925C21.5715 81.9974 19.9881 79.8953 20.0515 77.5271C20.1967 73.3283 20.7098 69.1492 21.5694 65.0383C22.0873 62.7157 24.1322 61.0591 26.512 61.038C27.171 61.0308 27.8812 61.0233 28.6172 61.0156C31.0614 60.9898 33.79 60.961 35.8735 60.9323C37.8964 60.9138 39.7183 59.6982 40.5137 57.8365C42.0645 54.2532 43.995 50.8488 46.2723 47.6781C47.4604 46.0405 47.5713 43.8469 46.5407 42.0968C45.1652 39.762 43.2424 36.4819 41.8063 34.0226C40.6051 31.9781 40.9713 29.3749 42.6941 27.746C45.7676 24.8781 49.0866 22.2882 52.6039 19.9894C54.607 18.7134 57.2352 18.9845 58.9287 20.6524L59.4301 21.1439C61.3929 23.0681 63.8327 25.46 65.626 27.1926C67.073 28.6099 69.2167 29.0384 71.0961 28.2809C74.7291 26.8502 78.4987 25.8065 82.3523 25.1744C84.3572 24.8541 85.9847 23.3839 86.4928 21.4198C87.1754 18.7934 88.1316 15.1164 88.8609 12.3617C89.456 10.0691 91.559 8.48677 93.9281 8.55213C98.1292 8.69779 102.311 9.21121 106.423 10.076C108.748 10.5869 110.405 12.631 110.427 15.0095C110.434 15.6355 110.441 16.3075 110.448 17.0039C110.475 19.4754 110.504 22.2536 110.533 24.3714C110.552 26.395 111.769 28.2093 113.632 29.0044C117.217 30.5601 120.624 32.4849 123.796 34.7614C125.435 35.9508 127.63 36.0602 129.38 35.0355C131.715 33.6627 134.998 31.7363 137.458 30.3046C139.503 29.1009 142.107 29.4723 143.738 31.1893C146.608 34.2616 149.2 37.5775 151.5 41.095C152.776 43.1024 152.506 45.7224 150.837 47.4199C148.843 49.4476 146.179 52.1646 144.295 54.1095C142.877 55.5538 142.448 57.7031 143.207 59.5748C144.639 63.2061 145.683 66.9757 146.316 70.8273C146.637 72.8312 148.108 74.4563 150.073 74.9645C152.701 75.647 156.38 76.6032 159.136 77.3324C161.43 77.9275 163.014 80.0296 162.949 82.3976C162.803 86.5964 162.29 90.7755 161.426 94.8858C160.915 97.2094 158.869 98.871 156.489 98.8922C153.641 98.9177 149.839 98.9554 147.123 98.9921C145.098 99.0155 143.283 100.234 142.487 102.095C140.932 105.673 139.007 109.076 136.73 112.247C135.54 113.886 135.431 116.078 136.456 117.83C136.743 118.318 137.054 118.848 137.38 119.403C138.614 121.502 140.057 123.957 141.191 125.902C142.395 127.947 142.024 130.551 140.306 132.181C137.233 135.047 133.915 137.639 130.396 139.937C128.388 141.213 125.767 140.941 124.068 139.272C122.039 137.281 119.32 134.622 117.374 132.732C115.929 131.315 113.778 130.888 111.906 131.644C108.273 133.075 104.501 134.124 100.648 134.752C98.6431 135.071 97.0171 136.543 96.5091 138.506C95.8266 141.132 94.8702 144.811 94.1411 147.564C93.546 149.856 91.443 151.439 89.0736 151.375C84.8725 151.229 80.6912 150.716 76.5781 149.856ZM61.1286 76.2321C59.071 92.99 71.0083 108.261 87.7751 110.319C104.537 112.377 119.814 100.448 121.871 83.6904C123.928 66.9376 111.991 51.667 95.2294 49.609C78.4626 47.5503 63.1856 59.4794 61.1286 76.2321Z"
          fill="#223C66"
        />
      </g>
      <g filter="url(#filter1_d_18702_103296)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.2454 203.599C45.8245 203.904 44.3823 203.18 43.7784 201.861L43.7784 201.861C43.2262 200.651 42.5458 199.168 42.011 198.022C41.5073 196.914 40.3971 196.208 39.1797 196.218C37.328 196.218 35.4802 196.042 33.6638 195.682C32.4694 195.438 31.2414 195.92 30.5317 196.914C29.7942 197.944 28.8436 199.27 28.065 200.346C27.2214 201.525 25.6701 201.957 24.338 201.39C22.5705 200.62 20.8651 199.712 19.2317 198.688C18.0124 197.899 17.5024 196.369 18.0115 195.007L18.0994 194.772C18.5468 193.574 19.0745 192.161 19.4796 191.043C19.9051 189.904 19.6226 188.622 18.7532 187.768C17.4437 186.461 16.2645 185.03 15.2372 183.493C14.5601 182.477 13.3539 181.95 12.149 182.15C11.9333 182.186 11.7068 182.223 11.473 182.262C10.3509 182.448 9.06029 182.662 7.97431 182.833C6.54526 183.073 5.14232 182.285 4.60173 180.94C3.89722 179.147 3.33254 177.301 2.90437 175.423C2.59892 174.002 3.32347 172.561 4.64736 171.956C5.85477 171.407 7.33996 170.726 8.49095 170.191C9.59655 169.687 10.3025 168.579 10.2935 167.362C10.2945 165.512 10.4712 163.666 10.835 161.85C11.0752 160.658 10.5933 159.43 9.60247 158.721C8.57072 157.985 7.24171 157.035 6.1651 156.258C4.98783 155.415 4.55305 153.866 5.12337 152.534C5.89362 150.768 6.80031 149.065 7.82582 147.431C8.61513 146.213 10.1492 145.703 11.5093 146.212C11.7023 146.284 11.902 146.358 12.1063 146.434C13.2214 146.849 14.4707 147.313 15.4775 147.678C16.6173 148.102 17.9003 147.82 18.7544 146.952C20.0635 145.642 21.4968 144.463 23.0376 143.437C24.0544 142.76 24.5829 141.554 24.383 140.351C24.1721 139.102 23.906 137.491 23.6971 136.181C23.4606 134.752 24.2491 133.35 25.5917 132.81C27.3873 132.107 29.235 131.542 31.1146 131.113C32.5358 130.808 33.9807 131.531 34.5828 132.854C34.7385 133.193 34.904 133.554 35.0734 133.923C35.5065 134.868 35.9649 135.867 36.3502 136.694C36.8556 137.797 37.9629 138.504 39.1806 138.494C41.032 138.494 42.8798 138.67 44.6971 139.033C45.8936 139.273 47.1186 138.791 47.8295 137.802C48.0219 137.534 48.2282 137.246 48.442 136.947C49.0507 136.097 49.7197 135.163 50.2984 134.366C51.1395 133.19 52.6899 132.755 54.0229 133.324C55.7903 134.095 57.4979 134.999 59.1286 136.025C60.3505 136.812 60.8585 138.345 60.3485 139.704C59.8837 140.949 59.3163 142.478 58.8807 143.67C58.4549 144.808 58.7407 146.089 59.6068 146.943C60.9164 148.251 62.0958 149.683 63.1267 151.221C63.8009 152.238 65.01 152.764 66.2122 152.566C67.4625 152.355 69.0744 152.089 70.3857 151.878C71.8157 151.642 73.2186 152.429 73.7583 153.772C74.4631 155.566 75.0278 157.412 75.4557 159.289C75.7612 160.71 75.0375 162.153 73.7157 162.754C73.4982 162.854 73.2718 162.958 73.04 163.064C71.9827 163.547 70.8138 164.082 69.8724 164.521C68.7645 165.028 68.0576 166.133 68.0666 167.35C68.0659 169.201 67.8889 171.046 67.5281 172.861C67.2861 174.058 67.7668 175.282 68.7608 175.991L68.7719 175.999C69.8027 176.736 71.1222 177.68 72.1959 178.456C73.3752 179.296 73.807 180.846 73.2399 182.178C72.4691 183.943 71.5605 185.65 70.5341 187.281C69.7457 188.502 68.214 189.009 66.8509 188.5L66.6431 188.423C65.4376 187.974 64.0119 187.444 62.8827 187.035C61.7426 186.61 60.4606 186.894 59.6059 187.761C58.2967 189.069 56.8632 190.248 55.3267 191.278C54.3086 191.95 53.7811 193.16 53.9803 194.361C54.0026 194.495 54.0255 194.633 54.049 194.774C54.2449 195.952 54.4792 197.36 54.6643 198.531C54.9024 199.958 54.1142 201.361 52.7683 201.902C50.973 202.606 49.1253 203.171 47.2454 203.599ZM24.3765 171.88C26.8738 180.044 35.5355 184.642 43.7042 182.146C51.8758 179.649 56.4811 170.997 53.9838 162.833C51.4871 154.671 42.8272 150.069 34.6557 152.566C26.4872 155.062 21.8798 163.718 24.3765 171.88Z"
          fill="#BFDEF3"
        />
      </g>
      <g filter="url(#filter2_d_18702_103296)">
        <ellipse
          cx="136.243"
          cy="127.365"
          rx="34.4613"
          ry="34.4611"
          fill="url(#paint0_linear_18702_103296)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.405 150.286C123.27 150.315 123.131 150.315 122.996 150.286C122.807 150.219 122.653 150.081 122.569 149.901C122.484 149.721 122.475 149.516 122.544 149.33L133.171 124.199H125.255C124.951 124.214 124.661 124.079 124.48 123.837C124.321 123.606 124.321 123.303 124.48 123.072L133.687 107.359C133.876 107.087 134.192 106.927 134.526 106.934H149.261C149.59 106.926 149.899 107.087 150.079 107.359C150.269 107.604 150.269 107.944 150.079 108.189L141.969 117.395H149.347C149.676 117.387 149.985 117.548 150.165 117.82C150.344 118.06 150.344 118.388 150.165 118.628L124.351 150.053C124.101 150.293 123.74 150.383 123.405 150.286V150.286Z"
        stroke="white"
        strokeWidth="1.73376"
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_d_18702_103296"
          x="17.9498"
          y="6.45017"
          width="155.1"
          height="155.027"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="3.05" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103296"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103296"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_18702_103296"
          x="0.734961"
          y="128.944"
          width="84.8904"
          height="84.8246"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="3.05" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103296"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103296"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_18702_103296"
          x="97.6813"
          y="89.8034"
          width="83.1229"
          height="83.1222"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="4" />
          <feGaussianBlur stdDeviation="3.55" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103296"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103296"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18702_103296"
          x1="163.5"
          y1="101.5"
          x2="111.001"
          y2="151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D0B4" />
          <stop offset="1" stopColor="#4186F6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
